<template>
  <utd-ai-header-btn class="ai-header-button-variant-alt" ui-element-name="ai-hero-btn">
    <div class="ai-header-arrow-container">
      <arrow-right class="ai-header-arrow" />
    </div>
  </utd-ai-header-btn>
</template>

<script setup>
import UtdAiHeaderBtn from '_acaSrc/components/header/UtdAiHeaderBtn.vue';
import ArrowRight from '_acaSrc/components/shared/svg/ArrowRight.vue';
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/wkce-app-spacing.less';
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

/* stylelint-disable declaration-property-value-no-unknown */

/* stylelint-disable-next-line */
@UTD-AI-HEADER-BTN-ARROW-COLOR-1: #AF9788;

.ai-header-button.ai-header-button-variant-alt {
  border: 1px solid @WK_UTD_WHITE_100;
  border-radius: 46px;
  gap: 10px;
  height: 58px;
  padding: 8px 20px;
  line-height: 24px;

  :deep(.ai-header-button-text-container) {
    .ai-header-button-text {
      color: @WK_UTD_WHITE_100;
      font-family: "Fira Sans", sans-serif;
      font-size: 18px;
    }
  }

  &:focus-visible {
    border: 2px solid @WKCE-BLACK;
  }

  &:hover {
    background-color: @WKCE-CREAM-TINT2;

    :deep(.ai-header-button-text) {
      color: @WKCE-GRAY-SHADE2;
    }

    .ai-header-arrow-container {
      .ai-header-arrow {
        color: @UTD-AI-HEADER-BTN-ARROW-COLOR-1;
      }
    }
  }

  &:active {
    background-color: @WKCE-CREAM-TINT1;

    :deep(.ai-header-button-text) {
      color: @WKCE-GRAY-SHADE2;
    }

    .ai-header-arrow-container {
      .ai-header-arrow {
        color: @UTD-AI-HEADER-BTN-ARROW-COLOR-1;
      }
    }
  }

  .ai-header-arrow-container {
    display: flex;
    align-items: center;

    .ai-header-arrow {
      width: 20px;
      height: 20px;
      color: @WK_UTD_WHITE_100;
    }
  }

  :deep(.ai-header-icon-container) {
    height: 28px;
    width: 28px;

    .ai-header-icon {
      width: 28px;
      height: 28px;
      background-image: url(~_acaAssets/utd-ai/utd-ai-spark-mobile.svg);
    }
  }

  &:hover,
  &:active {
    :deep(.ai-header-icon-container .ai-header-icon) {
      background-image: url(~_acaAssets/utd-ai/utd-ai-spark-mobile.svg);
    }
  }
}

.isDesktop {
  .ai-header-button.ai-header-button-variant-alt {
    margin-top: 40px; /* stylelint-disable-line */

    &:hover,
    &:active {
      :deep(.ai-header-icon-container .ai-header-icon) {
        background-image: url(~_acaAssets/utd-ai/utd-ai-spark.svg);
      }
    }
  }
}

/* stylelint-disable-next-line order/order */
@media (max-width: 430px) {
  .ai-header-button.ai-header-button-variant-alt {
    width: auto;
    height: 58px;
    border-radius: 46px;
    padding: 8px 20px;
    justify-content: flex-start;

    :deep(.ai-header-button-text-container) {
      display: flex;
    }
  }
}
</style>
